import React from 'react';
import PropTypes from 'prop-types';

const ContentOrder = ({ closeOrderSuspensionCancel }) => {
    return (
        <div className={'new-modal-container'}>
            <div className='new-modal-title-wrap'><div className='new-modal-title'>Suspender próximo envío</div></div>
            <div className={'new-modal-scroll'}>
                <div className="order-cancel-suspension-info">
                    <p>El envío programado para el <strong>12/09/2021</strong> entre 09:30 y 13:00 hrs sera suspendido y se reanudara el  12/10/2021 entre 09:30 y 13:00 </p>
                </div>
            </div>

            <div className={'modal-actions'}>
                <button className="secundary-btn btn-order-suspension-back" onClick={closeOrderSuspensionCancel}>Volver</button>
                <button className="primary-btn btn-order-suspension-confirm">Confirmar</button>
            </div>
        </div>
    )
}

ContentOrder.propTypes = {
    closeOrderSuspensionCancel: PropTypes.func,
}

export default ContentOrder;